import { useState, type CSSProperties } from "react";
import { formatDecimalPlaces } from "../../../../../helpers/format-decimal-places";
import { useGetAgenciesSalesTotal } from "../../../../../hooks/agencies-sales-details/use-get-agencies-sales-total";
import { useUserTimezone } from "../../../../../hooks/date/use-user-timezone";

const fieldStyle: CSSProperties = {
  padding: "8px",
  background: "#fff",
  border: "1px solid #d0d5e8",
  borderRadius: "6px",
  fontSize: "13px",
  boxSizing: "border-box",
  width: "100%",
  color: "#222",
};

const smallLabel: CSSProperties = {
  fontSize: "11px",
  color: "#e8ecff",
  marginBottom: "3px",
  display: "block",
};

// Card de fechamento na aba Venda: total vendido pela revenda no dia (ou período),
// com filtro de dia + intervalo de hora. Sem hora = dia inteiro (00:00–23:59).
export const SalesTotal = () => {
  const { todayInZone, zonedBoundToUtc } = useUserTimezone();

  const [date, setDate] = useState(todayInZone);
  const [timeInitial, setTimeInitial] = useState("");
  const [timeFinal, setTimeFinal] = useState("");

  // janela no fuso do usuário -> limites UTC (comparáveis ao created_at do banco)
  const dateTimeInitial = zonedBoundToUtc(
    date,
    timeInitial ? `${timeInitial}:00` : "00:00:00",
    false
  );
  const dateTimeFinal = zonedBoundToUtc(
    date,
    timeFinal ? `${timeFinal}:59` : "23:59:59",
    true
  );

  const { total, count, isFetching } = useGetAgenciesSalesTotal(
    { dateTimeInitial, dateTimeFinal },
    Boolean(date)
  );

  const isToday = date === todayInZone();

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #3f51b5, #5c6bc0)",
        borderRadius: "10px",
        padding: "14px 16px",
        marginBottom: "12px",
        color: "#fff",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
        }}
      >
        <span style={{ fontSize: "13px", opacity: 0.9 }}>
          Total vendido {isToday ? "hoje" : "no período"}
        </span>
        <span style={{ fontSize: "12px", opacity: 0.85 }}>
          {count} {count === 1 ? "venda" : "vendas"}
        </span>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginTop: "6px",
          marginBottom: "12px",
        }}
      >
        <img style={{ height: "20px", width: "20px" }} src="/coin.png" />
        <span style={{ fontSize: "26px", fontWeight: "bold" }}>
          {formatDecimalPlaces(total)}
        </span>
        {isFetching && (
          <span style={{ fontSize: "11px", opacity: 0.8 }}>atualizando…</span>
        )}
      </div>

      <div style={{ display: "flex", gap: "8px" }}>
        <div style={{ flex: 1.4, minWidth: 0 }}>
          <label style={smallLabel}>Dia</label>
          <input
            type="date"
            value={date}
            max={todayInZone()}
            onChange={(e) => setDate(e.target.value)}
            style={fieldStyle}
          />
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <label style={smallLabel}>De</label>
          <input
            type="time"
            value={timeInitial}
            max={timeFinal || undefined}
            onChange={(e) => setTimeInitial(e.target.value)}
            style={fieldStyle}
          />
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <label style={smallLabel}>Até</label>
          <input
            type="time"
            value={timeFinal}
            min={timeInitial || undefined}
            onChange={(e) => setTimeFinal(e.target.value)}
            style={fieldStyle}
          />
        </div>
      </div>
    </div>
  );
};
